import { Button, Col, Form, Input, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';
import { Formik } from 'formik';
import * as Yup from 'yup';
import i18n from '../../../../utils/i18n.ts';

type LinksModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: { title: string; url: string }) => void;
};

export default function LinksModal({ open, onClose, onSubmit }: LinksModalProps) {
  const { t } = useTranslation();

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <Modal
        title={t('form.field.links')}
        open={open}
        onCancel={handleCancel}
        footer={
          <Row justify="end" gutter={8}>
            <Col>
              <Button size="large" onClick={onClose}>
                {t('common.cancel')}
              </Button>
            </Col>
            <Col>
              <Button
                size="large"
                type="primary"
                icon={<FiCheck />}
                iconPosition="end"
                htmlType="submit"
                form="LINKS"
              >
                {t('common.confirm')}
              </Button>
            </Col>
          </Row>
        }
      >
        <Formik
          initialValues={{
            title: '',
            url: '',
          }}
          validationSchema={Yup.object().shape({
            title: Yup.string().required(i18n.t('error.validation.required-title')),
            url: Yup.string().required(i18n.t('error.validation.required-url')),
          })}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => {
            return (
              <Form layout="vertical" onFinish={handleSubmit} id="LINKS" autoComplete="off">
                <Form.Item
                  label={t('form.field.title')}
                  validateStatus={touched.title && errors.title ? 'error' : ''}
                  help={
                    touched.title && typeof errors.title === 'string' ? errors.title : undefined
                  }
                >
                  <Input
                    name="title"
                    variant="underlined"
                    defaultValue={values.title}
                    value={values.title}
                    onChange={handleChange}
                    placeholder={t('form.placeholder.type-here')}
                  />
                </Form.Item>
                <Form.Item
                  label={t('form.field.url')}
                  validateStatus={touched.url && errors.url ? 'error' : ''}
                  help={touched.url && typeof errors.url === 'string' ? errors.url : undefined}
                >
                  <Input
                    name="url"
                    variant="underlined"
                    defaultValue={values.url}
                    value={values.url}
                    onChange={handleChange}
                    placeholder={t('form.placeholder.type-here')}
                  />
                </Form.Item>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
}
